import type { PromotePageData } from '../../types';
import type { PromotePageMainDataQuery } from '../getPromotePageMainData.graphql';

import { normalizeSavedPaymentMethods } from './normalizeSavedPaymentMethods';

// eslint-disable-next-line complexity
export function normalizeUser({
	user,
	userProtectedData,
}: {
	user: PromotePageMainDataQuery['session']['user'];
	userProtectedData: PromotePageMainDataQuery['session']['userProtectedData'];
}): PromotePageData['user'] {
	return {
		country: user?.country || { countryCode: 'US' },
		email: userProtectedData?.email || '',
		displayName: user?.displayName || '',
		hasPaymentMethod: !!user?.hasPaymentMethod,
		id: user?.id || '',
		savedPaymentMethods: normalizeSavedPaymentMethods(userProtectedData?.paymentMethods),
		hasSubscription: !!user?.membership,
		// even though it's available in useCurrentUser(), we might as well retrieve the most recent value
		passwordSet: !!user?.passwordSet,
	};
}
